import type { FaireProductEntity } from "../../entity_types/product";

export const p_ncsfhnagdk: FaireProductEntity = {
  token: "p_ncsfhnagdk",
  type: "product",
  name: "“HIGH STRUNG” ADAPTOGENIC HERBAL EXTRACT",
  brandToken: "b_8i6qzemm69",
  brandName: "Roots To Remedies",
  imageUrl:
    "https://cdn.faire.com/fastly/d143a4b5432c154b00746839495bb344b9e3f8750339e84ade8888bee93663e1.jpeg",
  galleryImageUrls: [],
  priceDollars: 10.8,
  description:
    "\nStress is detrimental to our health. This adaptogenic blend can aid the body in reacting to or recovering from both short term and long term physical and mental stress.\n\n\n\nHERB BENEFITS:\n\n\nRed Ginseng- Several scientific studies showed the effectiveness of this ginseng in improving cognitive function, resulting in more focus and better memory. It is also linked to increased stamina, immune function and heart health.\n\nCodonopsis pilosula- Codonopsis is used to treat HIV infection and to protect cancer patients against side effects of radiation treatment. It has also been observed to boost the immune system; and to treat weakness, chronic diarrhea, shortness of breath, heart palpitations, asthma, cough, and diabetes.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:27.996Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
